const defaultTheme = {
	primaryColor: '#01487C',
	navyColor: '#0b2e4d',
	accentColor: '#5AB782',
	accentDarkColor: '#2f8a5a',
	inkColor: '#14212b',
	mutedColor: '#45535d',
	lineColor: '#dfe5e9',
	lineStrongColor: '#b9c4cc',
	softColor: '#f2f5f7',
	errorColor: '#c00',
	radius: '6px',
}

export default defaultTheme
